import { MutationTree } from "vuex";
import { IServiceAccountsState, getDefaultSAState } from ".";
import { IServiceAccount } from "@/models/serviceaccount";

export const mutations: MutationTree<IServiceAccountsState> = {
    setScopedSA(state, payload: IServiceAccount[]) {
        state.scopedSAError = null;
        state.SAScopedList = [...payload];
    },
    setUnscopedSA(state, payload: IServiceAccount[]) {
        state.unscopedSAError = null;
        state.SAUnscopedList = [...payload];
    },
    setSelectedServiceAccount(state, payload: IServiceAccount) {
        state.isSelectedServiceAccount = !!payload;
        state.selectedServiceAccount = payload;
    },
    setScopedSAError(state, payload: any) {
        state.scopedSAError = payload;
    },
    setUnscopedSAError(state, payload: any) {
        state.unscopedSAError = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultSAState());
    },
};
